import React, { useCallback, useEffect, useState } from 'react'
import { Collapse } from 'react-bootstrap'
import _ from 'lodash'

import LineChart from '../../linechart'
import PaceLoader from '../../paceloader'
import Heading from '../heading'
import RefreshButton from '../refresh_button'
import AnalyticsFilters from '../analytics_filters'
import ReportTableOrg from './report_org_table'
import ReportTableIndividual from './report_individual_table'

import { ApiHelper } from '../../../../helpers/apihelper'
import * as Constants from '../../../../helpers/constants'
import { buildApiFilters, getMetrics, getTableHeading, isOrgAdminView } from '../helpers'

/**
 * Port of cowebapp analytics/components/prospect/index.js — Prospect Usage
 * Report (report/prospect endpoint).
 */
const Prospect = ({ client, viewedUser, memberOptions }) => {

  const [metrics, setMetrics] = useState({
    totalPhoneLead: 0, totalEmailLead: 0, totalLead: 0, totalCredit: 0
  })
  const [isPerfSummaryOpen, setIsPerfSummaryOpen] = useState(true)
  const [usageStats, setUsageStats] = useState([])
  const [usageReports, setUsageReports] = useState([])
  const [showTable, setShowTable] = useState('individual')
  const [isStatsLoading, setIsStatsLoading] = useState(false)
  const [graphData, setGraphData] = useState(null)
  const [isGraphDataLoading, setIsGraphDataLoading] = useState(false)
  const [filters, setFiltersState] = useState({})

  const summaryToggle = () => {
    setIsPerfSummaryOpen(!isPerfSummaryOpen)
  }

  const getGraphData = useCallback((data) => {
    let stat = ''
    if (Object.prototype.hasOwnProperty.call(data, 'user_stats_org')) {
      stat = data.user_stats_org[0]
    } else {
      stat = data.user_stats[0]
    }
    let graphData = {
      breakdown: data.breakdown,
      labels: [],
      values: [
        {
          key: 'total_billable_email_contact', label: 'Email Contacts', data: [], borderColor: '#ffa500',
          backgroundColor: '#ffc04d0f', fill: true
        },
        {
          key: 'total_billable_phone_contact', label: 'Phone Contacts', data: [], borderColor: '#3cba9f',
          backgroundColor: '#71d1bd0f', fill: true
        },
        {
          key: 'total_billable_lead', label: 'Total Prospects', data: [], borderColor: '#cbbaf8',
          backgroundColor: '#d5c9f41f', fill: true
        },
        {
          key: 'total_credits_charged', label: 'Total Credits', data: [], borderColor: '#3e95cd',
          backgroundColor: '#7bb6dd12', fill: true
        },
      ],
    }

    stat.stats.forEach((data) => {
      graphData.labels.push(data.date)
    })
    graphData.values.forEach((item) => {
      stat.stats.forEach((data) => {
        Object.keys(data).forEach((key) => {
          if (key === item.key) {
            item.data.push(data[key])
          }
        })
      })
    })
    return graphData
  }, [])

  const getGraphOrgData = useCallback((data) => {
    let arrStats = []
    data.user_stats.forEach((data) => {
      data.stats.forEach((st) => {
        arrStats.push(st)
      })
    })
    let objStats = {}
    arrStats.forEach(function (d) {
      if (Object.prototype.hasOwnProperty.call(objStats, d.date)) {
        objStats[d.date] = {
          total_billable_lead: objStats[d.date].total_billable_lead + d.total_billable_lead,
          total_billable_email_contact: objStats[d.date].total_billable_email_contact + d.total_billable_email_contact,
          total_billable_phone_contact: objStats[d.date].total_billable_phone_contact + d.total_billable_phone_contact,
          total_credits_charged: objStats[d.date].total_credits_charged + d.total_credits_charged
        }
      } else {
        objStats[d.date] = {
          total_billable_email_contact: d.total_billable_email_contact,
          total_billable_lead: d.total_billable_lead,
          total_billable_phone_contact: d.total_billable_phone_contact,
          total_credits_charged: d.total_credits_charged
        }
      }
    })
    var userStatsOrg = [{ stats: [] }]
    for (var prop in objStats) {
      userStatsOrg[0].stats.push({
        date: prop,
        total_billable_email_contact: objStats[prop].total_billable_email_contact,
        total_billable_phone_contact: objStats[prop].total_billable_phone_contact,
        total_billable_lead: objStats[prop].total_billable_lead,
        total_credits_charged: objStats[prop].total_credits_charged
      })
    }
    data.user_stats_org = userStatsOrg

    return getGraphData(data)
  }, [getGraphData])

  const setterMetrics = useCallback((stats, role) => {
    let metrics = { totalPhoneLead: 0, totalEmailLead: 0, totalLead: 0, totalCredit: 0 }
    let totalEmailLead = 0
    let totalLead = 0
    let totalCredit = 0
    let totalPhoneLead = 0
    let tableData = []

    if (role === 'all') {
      stats.forEach((data) => {
        let total_billable_lead = 0
        let total_billable_email_contact = 0
        let total_billable_phone_contact = 0
        let total_credits_charged = 0
        data.stats.forEach((stat) => {
          if (stat.total_billable_lead > 0) {
            total_billable_lead = total_billable_lead + stat.total_billable_lead
            total_billable_email_contact = total_billable_email_contact + stat.total_billable_email_contact
            total_billable_phone_contact = total_billable_phone_contact + stat.total_billable_phone_contact
            total_credits_charged = total_credits_charged + stat.total_credits_charged
          }
        })
        tableData.push({
          total_billable_lead: total_billable_lead,
          total_billable_email_contact: total_billable_email_contact,
          total_credits_charged: total_credits_charged,
          total_billable_phone_contact: total_billable_phone_contact
        })
      })

      tableData.forEach((data) => {
        if (data.total_billable_lead > 0) {
          totalEmailLead = totalEmailLead + data.total_billable_email_contact
          totalLead = totalLead + data.total_billable_lead
          totalCredit = totalCredit + data.total_credits_charged
          totalPhoneLead = totalPhoneLead + data.total_billable_phone_contact
        }
      })
    } else {
      if (stats[0].stats) {
        stats = stats[0].stats
      }
      stats.forEach((data) => {
        if (data.total_billable_lead > 0) {
          totalEmailLead = totalEmailLead + data.total_billable_email_contact
          totalLead = totalLead + data.total_billable_lead
          totalPhoneLead = totalPhoneLead + data.total_billable_phone_contact
          totalCredit = totalCredit + data.total_credits_charged
        }
      })
    }

    metrics.totalPhoneLead = totalPhoneLead
    metrics.totalEmailLead = totalEmailLead
    metrics.totalLead = totalLead
    metrics.totalCredit = totalCredit

    return metrics
  }, [])

  const loadReportData = useCallback(() => {
    setIsGraphDataLoading(true)
    setIsStatsLoading(true)

    const { filters: apiFilters, selectedUserState } = buildApiFilters({
      viewedUser,
      memberFilter: filters.members,
      dateRangeFilter: filters.date_range
    })

    const queryParams = _.pick(
      { user_id: viewedUser.id, filters: JSON.stringify(apiFilters) },
      ApiHelper(client, 'PROSPECT_REPORTS').API_QUERY
    )

    ApiHelper(client, 'PROSPECT_REPORTS').API(client, queryParams)
      .then((res) => {
        setIsGraphDataLoading(false)
        if (res && res.status === Constants.CO_API.SUCCESS) {

          let usageStatsIndividualTable = selectedUserState.value.role === 'all' ?
            res.data.user_stats : res.data.user_stats[0].stats
          setUsageReports(res.data)

          setShowTable(selectedUserState.value.role === 'all' ? 'orgAllData' : 'individual')
          setUsageStats(usageStatsIndividualTable)
          setIsStatsLoading(false)
          let collectGraphData = selectedUserState.value.role === 'all'
            ? getGraphOrgData(res.data) : getGraphData(res.data)
          setGraphData(collectGraphData)
          setMetrics(setterMetrics(usageStatsIndividualTable, selectedUserState.value.role))
        }
      })
      .catch((err) => {
        setIsGraphDataLoading(false)
        setIsStatsLoading(false)
        console.log('UsageReports api erred', err)
      })
  }, [client, viewedUser, filters, getGraphData, getGraphOrgData, setterMetrics])

  useEffect(() => {
    if (!_.isEmpty(filters)) {
      loadReportData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  const refreshReports = () => {
    loadReportData()
  }

  const onSetFilters = (filters) => {
    setFiltersState({ ...filters })
  }

  return (
    <div className="analytics-graph-content">
      <div className="report-header col-12 d-flex justify-content-between align-items-center">
        <div className="report-date-filter">
          <Heading
            toolTipMessage="Find your credit utilization of the prospecting service"
            title="Prospect Usage Report"
          />
        </div>
      </div>
      <div className="report-header col-12 d-flex justify-content-between align-items-center">
        <AnalyticsFilters
          client={client}
          viewedUser={viewedUser}
          memberOptions={memberOptions}
          filterState={filters}
          onSetFilters={onSetFilters}
        />
        <RefreshButton onRefresh={refreshReports} />
      </div>
      <div className="report-content ps-3 pe-3">
        <PaceLoader isLoading={isStatsLoading} />
        <div>
          <div className="d-flex report-performance-summary report-performance-summary-new g-0 flex-column report-prospect-summary pt-3">
            <div className="page-report-heading">
              <h3 className="m-0">Summary</h3>
              <div className="btn-toolbar">
                <div className="btn-group">
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => summaryToggle()}
                  >
                    {isPerfSummaryOpen === true ? (
                      <i className="fa fa-chevron-up"></i>
                    ) : (
                      <i className="fa fa-chevron-down"></i>
                    )}
                  </button>
                </div>
              </div>
            </div>
            <Collapse in={isPerfSummaryOpen}>
              <div className="graph-content">
                <div className="metrics">
                  <div className="metrics-content">
                    <div className="total-verified">
                      <span>Total Prospects</span>
                      {getMetrics(
                        metrics.totalLead,
                        2,
                        '',
                        '',
                        'Total Prospects'
                      )}
                    </div>
                    <div className="total-verified">
                      <span>Total Credits</span>
                      {getMetrics(
                        metrics.totalCredit,
                        2,
                        '',
                        '',
                        'Total Credits'
                      )}
                    </div>
                    <div className="total-verified">
                      <span>Email Contacts</span>
                      {getMetrics(
                        metrics.totalEmailLead,
                        0,
                        '',
                        '',
                        'Email Contacts'
                      )}
                    </div>
                    <div className="total-verified">
                      <span>Phone Contacts</span>
                      {getMetrics(
                        metrics.totalPhoneLead,
                        0,
                        '',
                        '',
                        'Phone Contacts'
                      )}
                    </div>
                  </div>
                </div>
                <div className="area-graph">
                  <LineChart
                    graphData={graphData}
                    isGraphDataLoading={isGraphDataLoading}
                    width={300}
                    height={250}
                    position="bottom"
                  />
                </div>
              </div>
            </Collapse>
          </div>
        </div>
        <div>
          <div className="d-flex report-performance-breakdown g-0 flex-column">
            <div className="page-report-heading">
              <h3 className="m-0 d-flex align-items-center">
                {getTableHeading(isOrgAdminView(viewedUser) ? 'all' : viewedUser.user_role, usageReports.breakdown)}
              </h3>
            </div>
            {!isStatsLoading &&
              showTable === 'orgAllData'
              ? <ReportTableOrg
                userReportData={usageReports}
                tableData={usageStats}
              />
              : <ReportTableIndividual
                userReportData={usageReports}
                tableData={usageStats}
              />
            }
          </div>
        </div>
        <div className="report-footnote">
          <i
            className="fa fa-exclamation-circle"
            aria-hidden="true"
          >
          </i>
          <small className="form-text">
            Row will be supressed when no activity found for the particular
            day or hour for the chosen period
          </small>
        </div>
      </div>
    </div>
  )
}

export default Prospect
